import update from 'immutability-helper';
import React, { Dispatch, SetStateAction } from 'react';
import { DraggableColumn, SavedColumnPresets } from '~/components/SearchColumns';
import { Select } from '~/components/Select';
import { ServicesContext, colFieldMap } from '~/services';

interface SearchColumnsProps {
    selectedPreset: string;
    setSelectedPreset: (preset: string) => void;
    orderedColumns: string[];
    updateOrderedColumns: Dispatch<SetStateAction<string[]>>;
}
export function SearchColumns({
    selectedPreset,
    setSelectedPreset,
    orderedColumns,
    updateOrderedColumns,
}: SearchColumnsProps) {
    const context = React.useContext(ServicesContext);
    const addColOptions = Object.keys(colFieldMap)
        .filter((col) => !orderedColumns.includes(col))
        .filter(
            (col) => !(context.user.hasFeatureToggle('hidden_foc') && col.substring(0, 2) === 'AW')
        )
        .map((col) => ({ label: col, value: col }));

    const addColumn = ({ value }: { label: string; value: string }) => {
        updateOrderedColumns((prevColumns: string[]) => prevColumns.concat(value));
    };

    const removeCol = React.useCallback(
        (column: string) => {
            updateOrderedColumns((prevColumns: string[]) =>
                prevColumns.filter((x) => x !== column)
            );
        },
        [updateOrderedColumns]
    );

    const moveCol = React.useCallback(
        (dragIndex: number, hoverIndex: number) => {
            updateOrderedColumns((prevColumns: string[]) => {
                const updatedCols = update(prevColumns, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, prevColumns[dragIndex] as string],
                    ],
                });
                return updatedCols;
            });
        },
        [updateOrderedColumns]
    );

    const renderColumn = React.useCallback(
        (column: string, index: number) => {
            return (
                <DraggableColumn
                    key={column}
                    id={column}
                    column={column}
                    moveCol={moveCol}
                    index={index}
                    removeCol={removeCol}
                />
            );
        },
        [moveCol, removeCol]
    );

    return (
        <div className="container">
            <SavedColumnPresets
                orderedColumns={orderedColumns}
                selectedPreset={selectedPreset}
                setSelectedPreset={setSelectedPreset}
            />
            <div className="row">
                <div className="col col-md-10 offset-md-1 mt-2">
                    <Select
                        options={addColOptions}
                        placeholder="Add Column"
                        label="Add Column"
                        onChange={addColumn}
                        value={null}
                    />
                </div>
            </div>
            <hr className="my-3" />
            <div className="row columns-container">
                <div className="col">
                    {['First Name', 'Last Name', 'DOB'].map((col) => (
                        <div key={col} className="ordered-column border rounded ps-5 my-2">
                            {col}
                        </div>
                    ))}
                    {orderedColumns.map((col, i) => renderColumn(col, i))}
                </div>
            </div>
        </div>
    );
}
